import React from 'react';
const CarReminders = () => <div style={{padding:32}}>Сануулга (stub)</div>;
export default CarReminders;
